import './button.scss';

import React from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LocalizedLink from './LocalizedLink';


export type ButtonProps = {
    children?: React.ReactNode;
    isLoading?: boolean;
    disabled?: boolean;
    className?: string;
    link?: string;
    form?: string;
    icon?: string;
    faIcon?: IconProp;
    label?: string;
    labelHidden?: boolean;
    onClick?: (e: any) => void;
};

export default function Button(props: ButtonProps) {
    const {
        children,
        disabled,
        className,
        link,
        form,
        icon,
        faIcon,
        label,
        labelHidden,
        onClick,
        isLoading,
    } = props;

    // todo : hover change icon
    const Label = () => {
        let text = children || label;

        return (
            <>
                {isLoading ? (
                    <FontAwesomeIcon
                        className='spinner'
                        icon={faSpinnerThird}
                        spin
                    />
                ) : (
                    <div>
                        {icon && <img src={icon} alt={icon} />}
                        {faIcon && (
                            <FontAwesomeIcon className='faIcon' icon={faIcon} />
                        )}
                        {text && labelHidden !== true && (
                            <span className='text'>{text}</span>
                        )}
                    </div>
                )}
            </>
        );
    };

    return link ? (
        <LocalizedLink to={link} className={`button ${className}`}>
            <Label />
        </LocalizedLink>
    ) : (
        <button
            disabled={disabled || isLoading}
            onClick={onClick && ((e) => onClick(e))}
            className={
                disabled
                    ? `button disabled ${className}`
                    : `button ${className}`
            }
            form={form}
        >
            <Label />
        </button>
    );
}
